import React from "react";
import "./Tabs.css";

const Tabs = ({ tabs, activeTab, onTabChange, isMobile }) => {
  return (
    <div className={`tabs ${isMobile ? "mobile" : "desktop"}`}>
      {tabs.map((tab, index) => (
        <button
          key={index}
          className={`tab ${activeTab === index ? "active" : ""}`}
          onClick={() => onTabChange(index)}
        >
          {tab}
          <span className="tab-indicator"></span>
        </button>
      ))}
    </div>
  );
};

export default Tabs;
